// Define un tipo genérico para el entorno

import { Injector } from "@angular/core";
import { ENV } from "../interfaces/interfaces";
import { ConfigProjectService } from "../services/config.service";

export function getEnvironment(): ENV {
    const injector = Injector.create({providers: [{provide: ConfigProjectService, useClass: ConfigProjectService, deps: []}]});
    const configProjectService = injector.get(ConfigProjectService);
    const env = configProjectService.getAllEnv();
    return env;
}